import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['button', 'modalBg', 'modal', 'trigger']


    open(event) {
        let button = this.buttonTarget
        let id = button.dataset.id
        let hidden_fields = button.dataset.hiddenFields
        let modalDiv = document.getElementById("reason-modal-div-" + id)
        modalDiv.dataset.dataComponentId = id
        const modalTitle = modalDiv.querySelector('#modal-title')
        if (modalTitle) modalTitle.innerHTML = button.dataset.reasonLabel
        let form = document.getElementById("reason-form-" + id)
        this.addHiddenFields(form, hidden_fields)
        this.setupReasonInput(form)

        // Add form submit event listener to handle value combination
        form.addEventListener('submit', this.handleFormSubmit.bind(this))

        form.querySelector('#resource-id').value = button.dataset.resourceId
        form.querySelector('#action-name').value = button.dataset.actionName
        form.querySelector('#reason-name').name = button.dataset.reasonName
        form.querySelector('#resource-type').value = button.dataset.resourceType
        form.querySelector('#submit-btn').value = button.dataset.submitLabel
        modalDiv.classList.remove('hidden');
        modalDiv.querySelector('.modalBg').classList.remove('hidden')
        modalDiv.querySelector('.modalBg').dataset.dataComponentId = this.id
        modalDiv.querySelector('.modal').classList.remove('hidden')
    }

    addHiddenFields(form, hiddenFieldsData) {
        // Remove any existing dynamic hidden fields first
        this.removeHiddenFields(form)

        if (!hiddenFieldsData) return

        let hiddenFields
        try {
            // Parse the hidden fields data (assuming it's JSON string from Rails)
            hiddenFields = typeof hiddenFieldsData === 'string' ? JSON.parse(hiddenFieldsData) : hiddenFieldsData
        } catch (e) {
            console.warn('Could not parse hidden fields data:', e)
            return
        }

        // Create and append hidden input fields
        Object.entries(hiddenFields).forEach(([key, value]) => {
            const hiddenInput = document.createElement('input')
            hiddenInput.type = 'hidden'
            hiddenInput.name = key
            hiddenInput.value = value
            hiddenInput.classList.add('dynamic-hidden-field') // Add class for easy removal
            form.appendChild(hiddenInput)
        })
    }

    removeHiddenFields(form) {
        // Remove all dynamically added hidden fields
        const dynamicFields = form.querySelectorAll('.dynamic-hidden-field')
        dynamicFields.forEach(field => field.remove())
    }

    close(event) {
        this.resetValues()
        this.modalBgTarget.classList.add('hidden')
        this.modalTarget.classList.add('hidden')
    }

    setupReasonInput(form) {
        const reasonOptions = this.buttonTarget.dataset.reasonOptions
        const reasonInput = form.querySelector('#reason-name')

        if (reasonOptions) {
            // Parse reason options from JSON
            let options
            try {
                options = JSON.parse(reasonOptions)
            } catch (e) {
                return
            }

            // Create select element
            const select = document.createElement('select')
            select.id = reasonInput.id
            select.name = reasonInput.name
            select.className = reasonInput.className
            select.required = reasonInput.required


            // Add default option
            const defaultOption = document.createElement('option')
            defaultOption.value = ''
            defaultOption.textContent = 'Select a reason...'
            defaultOption.disabled = true
            defaultOption.selected = true
            select.appendChild(defaultOption)

            // Add options from configuration
            options.forEach(option => {
                const optionElement = document.createElement('option')
                optionElement.value = option.value || option
                optionElement.textContent = option.label || option
                select.appendChild(optionElement)
            })

            // Add event listener to handle 'Other' selection
            select.addEventListener('change', this.handleReasonChange.bind(this, form))

            // Replace textarea with select
            reasonInput.parentNode.replaceChild(select, reasonInput)
        }
    }

    handleReasonChange(event, form) {
        const select = event.target
        const selectedValue = select.value

        // Remove existing 'other' textarea and hidden input if present
        const existingOtherTextarea = form.querySelector('.other-reason-textarea')
        const existingHiddenInput = form.querySelector('.combined-reason-input')

        if (existingOtherTextarea) {
            existingOtherTextarea.remove()
        }
        if (existingHiddenInput) {
            existingHiddenInput.remove()
            // Restore the name to the select element
            select.name = existingHiddenInput.name
        }

        // If 'Other' is selected, add a textarea and hidden input
        if (selectedValue === 'Other') {
            const textarea = document.createElement('textarea')
            textarea.className = 'other-reason-textarea block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm mt-2'
            textarea.placeholder = 'Please specify your reason...'
            textarea.required = true
            textarea.rows = 3

            // Add event listener to update combined value as user types
            textarea.addEventListener('input', () => {
                this.updateCombinedReason(textarea)
            })

            // Create hidden input to store the actual combined value that will be submitted
            const hiddenInput = document.createElement('input')
            hiddenInput.type = 'hidden'
            hiddenInput.name = select.name  // Use the same name as the select
            hiddenInput.className = 'combined-reason-input'
            hiddenInput.value = 'Other'  // Default value

            // Remove the name from the select so it doesn't conflict
            select.name = ''

            // Insert textarea and hidden input after the select element
            select.parentNode.insertBefore(textarea, select.nextSibling)
            select.parentNode.insertBefore(hiddenInput, textarea.nextSibling)


            // Trigger an initial update to make sure everything is working
            this.updateCombinedReason(textarea)
        }
    }

    updateCombinedReason(textarea) {
        // Find the hidden input that should be right after the textarea
        const hiddenInput = textarea.parentNode.querySelector('.combined-reason-input')


        if (hiddenInput) {
            if (textarea.value.trim()) {
                const combinedValue = `Other, ${textarea.value.trim()}`
                hiddenInput.value = combinedValue
            } else {
                hiddenInput.value = 'Other'
            }
        } else {
        }
    }

    handleFormSubmit(event) {
        const form = event.target
        const hiddenInput = form.querySelector('.combined-reason-input')
        const reasonSelect = form.querySelector('#reason-name')
        const otherTextarea = form.querySelector('.other-reason-textarea')


        // Last chance to update the combined value before submission
        if (hiddenInput && otherTextarea) {
            if (otherTextarea.value.trim()) {
                hiddenInput.value = `Other, ${otherTextarea.value.trim()}`
            }
        }
    }

    resetValues() {
        let form = document.getElementById("reason-form-" + this.element.id)
        form.querySelector('#resource-id').value = undefined
        form.querySelector('#action-name').value = undefined
        form.querySelector('#reason-name').name = 'Reason'
        form.querySelector('#reason-name').value = null
        form.querySelector('#resource-type').value = undefined
        form.querySelector('#submit-btn').value = undefined

        // Remove 'other' textarea and hidden input if present
        const existingOtherTextarea = form.querySelector('.other-reason-textarea')
        const existingHiddenInput = form.querySelector('.combined-reason-input')

        if (existingOtherTextarea) {
            existingOtherTextarea.remove()
        }
        if (existingHiddenInput) {
            existingHiddenInput.remove()
        }

        // Remove form submit event listener to avoid duplicates
        if (form && this.handleFormSubmit) {
            form.removeEventListener('submit', this.handleFormSubmit)
        }

        // Reset reason input to original textarea if it was changed to select
        this.resetReasonInput(form)
    }

    resetReasonInput(form) {
        const reasonInput = form.querySelector('#reason-name')

        // If current input is a select, replace it back with textarea
        if (reasonInput && reasonInput.tagName === 'SELECT') {
            const textarea = document.createElement('textarea')
            textarea.id = 'reason-name'
            textarea.name = 'Reason'
            textarea.className = 'block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm'
            textarea.required = true
            textarea.rows = 4
            textarea.cols = 4

            reasonInput.parentNode.replaceChild(textarea, reasonInput)
        }
    }

}
